<template>
    <div id="widget_settings_tab">
        <div
            class="mobile-widget-preview-show-btn"
            @click="showMobileWidgetPreview()"
        >
            <span>{{ $t("widgetTab.previewBtn") }}</span>
            <i class="la la-angle-right"></i>
        </div>
        <div class="bb-card widget-form-card">
            <b-button
                v-b-toggle.collapse-appearance
                class="bb-colapse"
                @click="appearanceOpen != appearanceOpen"
                ><div class="collapse-btn-left">
                    <svg
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M5 12C3.34 12 2 13.34 2 15C2 16.31 0.84 17 0 17C0.92 18.22 2.49 19 4 19C6.21 19 8 17.21 8 15C8 13.34 6.66 12 5 12ZM18.71 2.63L17.37 1.29C16.98 0.899998 16.35 0.899998 15.96 1.29L7 10.25L9.75 13L18.71 4.04C19.1 3.65 19.1 3.02 18.71 2.63Z"
                            fill="#1A73E8"
                        />
                    </svg>
                    <span>{{ $t("widgetTab.appearance.title") }}</span>
                </div>
                <i :class="appearanceArrowClass"></i
            ></b-button>
            <b-collapse v-model="appearanceOpen" id="collapse-appearance">
                <div class="bb-form-group inline-form-group">
                    <label>{{
                        $t("widgetTab.appearance.logoInput.label")
                    }}</label>
                    <input
                        type="file"
                        style="display: none"
                        ref="logoInput"
                        @change="onFileChange"
                    />
                    <div
                        class="widget-logo-placeholder"
                        v-if="!form.fields.logo && !form.helpers.logo"
                        @click="uploadLogo()"
                    >
                        <svg
                            width="24"
                            height="26"
                            viewBox="0 0 44 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M25.7059 7.21622H5.94118C4.63069 7.21622 3.37389 7.74015 2.44724 8.67277C1.52059 9.60538 1 10.8703 1 12.1892V37.0541M1 37.0541V42.027C1 43.3459 1.52059 44.6108 2.44724 45.5434C3.37389 46.4761 4.63069 47 5.94118 47H35.5882C36.8987 47 38.1555 46.4761 39.0822 45.5434C40.0088 44.6108 40.5294 43.3459 40.5294 42.027V32.0811M1 37.0541L12.3301 25.651C13.2567 24.7187 14.5133 24.195 15.8235 24.195C17.1338 24.195 18.3903 24.7187 19.3169 25.651L25.7059 32.0811M40.5294 19.027V32.0811M40.5294 32.0811L36.6111 28.1375C35.6844 27.2052 34.4279 26.6815 33.1176 26.6815C31.8074 26.6815 30.5508 27.2052 29.6242 28.1375L25.7059 32.0811M25.7059 32.0811L30.6471 37.0541M33.1176 5.97297H43M38.0588 1V10.9459M25.7059 17.1622H25.7306"
                                stroke="#99ACC2"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <span>{{
                            $t("widgetTab.appearance.logoInput.description")
                        }}</span>
                    </div>
                    <img
                        class="widget-logo"
                        :src="logoPath"
                        v-if="form.fields.logo || form.helpers.logo"
                        @click="uploadLogo()"
                    />
                </div>
                <div class="bb-invalid-feedback" v-show="form.errors.logo">
                    {{ form.errors.logo }}
                </div>
                <div class="bb-form-group inline-form-group">
                    <label>{{
                        $t("widgetTab.appearance.colorInput.label")
                    }}</label>
                    <div class="background-colors-container">
                        <div
                            class="bb-badge badge-rounded widget-color-badge"
                            @click="selectColor(color)"
                            v-for="(color, index) in availableColors"
                            :key="index"
                            :style="'background: ' + color + ';'"
                        >
                            <svg
                                v-show="color === form.fields.backgroundColor"
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.04965 13.2353C5.76596 13.2353 5.48227 13.1209 5.25532 12.8922L1.34043 8.94722C0.886525 8.48983 0.886525 7.80374 1.34043 7.34634C1.79433 6.88895 2.47518 6.88895 2.92908 7.34634L5.99291 10.4338L15.0709 1.34305C15.5248 0.885651 16.2057 0.885651 16.6596 1.34305C17.1135 1.80044 17.1135 2.48653 16.6596 2.94393L6.84397 12.8922C6.61702 13.1209 6.33333 13.2353 6.04965 13.2353Z"
                                    fill="white"
                                    stroke="white"
                                />
                            </svg>
                        </div>
                        <div
                            class="bb-badge badge-rounded widget-color-badge add-new"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-more-horizontal"
                            >
                                <circle cx="12" cy="12" r="1"></circle>
                                <circle cx="19" cy="12" r="1"></circle>
                                <circle cx="5" cy="12" r="1"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
                <div
                    class="bb-invalid-feedback"
                    v-show="form.errors.backgroundColor"
                >
                    {{ form.errors.backgroundColor }}
                </div>
                <div class="bb-form-group inline-form-group">
                    <label>{{
                        $t("widgetTab.appearance.statusInput.label")
                    }}</label>
                    <input
                        class="bb-input"
                        type="text"
                        v-model="form.fields.status"
                    />
                </div>
                <div class="bb-invalid-feedback" v-show="form.errors.status">
                    {{ form.errors.status }}
                </div>
                <div class="bb-form-group inline-form-group">
                    <label>{{
                        $t("widgetTab.appearance.messageInput.label")
                    }}</label>
                    <input
                        class="bb-input"
                        type="text"
                        v-model="form.fields.message"
                    />
                </div>
                <div class="bb-invalid-feedback" v-show="form.errors.message">
                    {{ form.errors.message }}
                </div>
                <div class="bb-form-group inline-form-group">
                    <BBSwitch
                        :label="
                            $t('widgetTab.appearance.showReviewsInput.label')
                        "
                        v-model="form.fields.showReviews"
                    />
                </div>
                <div
                    class="bb-invalid-feedback"
                    v-show="form.errors.showReviews"
                >
                    {{ form.errors.showReviews }}
                </div>
            </b-collapse>
            <b-button
                v-b-toggle.collapse-installation
                class="bb-colapse"
                @click="installationOpen != installationOpen"
                ><div class="collapse-btn-left">
                    <svg
                        width="20"
                        height="10"
                        viewBox="0 0 20 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.9 5C1.9 3.29 3.29 1.9 5 1.9H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8.1H5C3.29 8.1 1.9 6.71 1.9 5ZM6 6H14V4H6V6ZM15 0H11V1.9H15C16.71 1.9 18.1 3.29 18.1 5C18.1 6.71 16.71 8.1 15 8.1H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0Z"
                            fill="#1A73E8"
                        />
                    </svg>
                    <span>{{ $t("widgetTab.installation.title") }}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#F6303A"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-alert-octagon"
                    >
                        <polygon
                            points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                        ></polygon>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>
                <i :class="installationArrowClass"></i
            ></b-button>
            <b-collapse v-model="installationOpen" id="collapse-installation">
                <p>
                    {{ $t("widgetTab.installation.description") }}
                </p>
                <input
                    type="hidden"
                    id="copy_input"
                    v-model="widgetCodeString"
                />
                <div class="installation-card-wrapper">
                    <div
                        class="installation-card"
                        @click="jsInstructionsVisible = !jsInstructionsVisible"
                    >
                        <div>
                            <svg
                                width="11"
                                height="20"
                                viewBox="0 0 11 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                            >
                                <path
                                    d="M9.66638 2L1.66638 10L9.66638 18"
                                    stroke="#1A73E8"
                                    stroke-width="2.28571"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <svg
                                width="11"
                                height="20"
                                viewBox="0 0 11 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.33362 18L9.33362 10L1.33362 2"
                                    stroke="#1A73E8"
                                    stroke-width="2.28571"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <span>JavaScript</span>
                        <div class="placeholder"></div>
                    </div>
                    <div
                        class="installation-card-instructions"
                        v-show="jsInstructionsVisible"
                    >
                        <p class="instruction-text">
                            {{
                                $t(
                                    "widgetTab.installation.jsCard.instructions.step1"
                                )
                            }}
                        </p>
                        <div class="code-preview">
                            {{ widgetCodeString }}
                        </div>
                        <div class="installation-card-instructions-footer">
                            <button
                                class="bb-btn btn-success"
                                @click="copyToClipboard()"
                            >
                                {{
                                    $t("widgetTab.installation.jsCard.copyBtn")
                                }}
                            </button>
                            <div class="contact-us-section">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#1A73E8"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-info"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line
                                        x1="12"
                                        y1="16"
                                        x2="12"
                                        y2="12"
                                    ></line>
                                    <line
                                        x1="12"
                                        y1="8"
                                        x2="12.01"
                                        y2="8"
                                    ></line>
                                </svg>
                                <span class="need-help">{{
                                    $t(
                                        "widgetTab.installation.jsCard.needHelpLabel"
                                    )
                                }}</span>
                                <span class="contact-us">{{
                                    $t(
                                        "widgetTab.installation.jsCard.contactUsLabel"
                                    )
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="installation-card-wrapper">
                    <div
                        class="installation-card"
                        @click="wpInstructionsVisible = !wpInstructionsVisible"
                    >
                        <div>
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.2655 16.0001C2.2655 21.4332 5.4106 26.1285 9.97125 28.3535L3.44924 10.4139C2.6906 12.121 2.2655 14.0101 2.2655 16.0001ZM25.1681 15.3074C25.1681 13.611 24.5612 12.4362 24.0406 11.5218C23.3475 10.3912 22.6979 9.43366 22.6979 8.303C22.6979 7.04123 23.6511 5.86669 24.9938 5.86669C25.0544 5.86669 25.1119 5.87426 25.171 5.87766C22.7385 3.64037 19.4976 2.27438 15.9381 2.27438C11.1615 2.27438 6.95909 4.73472 4.51434 8.46128C4.83512 8.47094 5.13743 8.47773 5.39421 8.47773C6.82433 8.47773 9.03805 8.30352 9.03805 8.30352C9.77509 8.25991 9.86198 9.34669 9.12572 9.43419C9.12572 9.43419 8.38504 9.52168 7.56085 9.56504L12.5398 24.4329L15.532 15.4239L13.4018 9.56452C12.6655 9.52116 11.968 9.43366 11.968 9.43366C11.2312 9.39031 11.3176 8.25938 12.0544 8.303C12.0544 8.303 14.3123 8.47721 15.6558 8.47721C17.0857 8.47721 19.2996 8.303 19.2996 8.303C20.0372 8.25938 20.1238 9.34617 19.3873 9.43366C19.3873 9.43366 18.6451 9.52116 17.8224 9.56452L22.7634 24.3198L24.1272 19.7446C24.7183 17.8461 25.1681 16.4825 25.1681 15.3074ZM16.178 17.2007L12.0757 29.1679C13.3006 29.5293 14.5959 29.727 15.9381 29.727C17.5303 29.727 19.0572 29.4507 20.4784 28.949C20.4418 28.8902 20.4085 28.8278 20.3811 28.7599L16.178 17.2007ZM27.9352 9.4146C27.994 9.85182 28.0273 10.3212 28.0273 10.826C28.0273 12.2189 27.7682 13.7847 26.9877 15.7425L22.8113 27.8648C26.8761 25.4852 29.6101 21.0641 29.6101 16.0003C29.6104 13.6139 29.0032 11.3698 27.9352 9.4146ZM15.9381 0C7.15005 0 0 7.17757 0 16.0001C0 24.8236 7.15005 32.0009 15.9381 32.0009C24.7259 32.0009 31.8769 24.8236 31.8769 16.0001C31.8767 7.17757 24.7259 0 15.9381 0ZM15.9381 31.2675C7.55304 31.2675 0.730797 24.4185 0.730797 16.0001C0.730797 7.58214 7.55278 0.733663 15.9381 0.733663C24.3229 0.733663 31.1446 7.58214 31.1446 16.0001C31.1446 24.4185 24.3229 31.2675 15.9381 31.2675Z"
                                    fill="#464342"
                                />
                            </svg>
                        </div>
                        <span>WordPress</span>
                        <div class="placeholder"></div>
                    </div>
                    <div
                        class="installation-card-instructions"
                        v-show="wpInstructionsVisible"
                    >
                        <p class="instruction-text">
                            1.
                            {{
                                $t(
                                    "widgetTab.installation.wpCard.instructions.step1"
                                )
                            }}
                        </p>
                        <p class="instruction-text">
                            2.
                            {{
                                $t(
                                    "widgetTab.installation.wpCard.instructions.step2"
                                )
                            }}
                        </p>
                        <p class="instruction-text">
                            3.
                            {{
                                $t(
                                    "widgetTab.installation.wpCard.instructions.step3"
                                )
                            }}
                        </p>
                        <p class="instruction-text">
                            4.
                            {{
                                $t(
                                    "widgetTab.installation.wpCard.instructions.step4"
                                )
                            }}
                        </p>
                        <p class="instruction-text">
                            5.
                            {{
                                $t(
                                    "widgetTab.installation.wpCard.instructions.step5"
                                )
                            }}
                        </p>
                        <div class="code-preview">
                            {{ widgetCodeString }}
                        </div>
                        <div class="installation-card-instructions-footer">
                            <button
                                class="bb-btn btn-success"
                                @click="copyToClipboard()"
                            >
                                {{
                                    $t("widgetTab.installation.wpCard.copyBtn")
                                }}
                            </button>
                            <div class="contact-us-section">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#1A73E8"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-info"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line
                                        x1="12"
                                        y1="16"
                                        x2="12"
                                        y2="12"
                                    ></line>
                                    <line
                                        x1="12"
                                        y1="8"
                                        x2="12.01"
                                        y2="8"
                                    ></line>
                                </svg>
                                <span class="need-help">{{
                                    $t(
                                        "widgetTab.installation.wpCard.needHelpLabel"
                                    )
                                }}</span>
                                <span class="contact-us">{{
                                    $t(
                                        "widgetTab.installation.wpCard.contactUsLabel"
                                    )
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <div class="widget-form-card-footer">
                <button class="bb-btn btn-success" @click="submit()">
                    {{ $t("widgetTab.saveBtn") }}
                </button>
            </div>
        </div>
        <div class="widget-preview-wrapper" v-show="widgetPreviewVisible">
            <div class="widget-preview">
                <div
                    class="mobile-widget-preview-hide-btn"
                    @click="hideMobileWidgetPreview()"
                >
                    <i class="la la-angle-left"></i>
                    <span>{{ $t("widgetTab.backBtn") }}</span>
                </div>
                <div
                    class="top-section"
                    :style="'background:' + form.fields.backgroundColor + ';'"
                >
                    <img :src="logoPath" />
                    <h2>{{ form.fields.status }}</h2>
                    <span>{{ form.fields.message }}</span>
                </div>
                <div class="bottom-section"></div>
                <div class="start-booking-section">
                    <span class="section-title">
                        {{ $t("widgetTab.widget.startBookingLabel") }}</span
                    >
                    <div class="next-free-time-example">
                        <div class="badges-container">
                            <div
                                class="bb-badge badge-rounded background-badge"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#99ACC2"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-user"
                                >
                                    <path
                                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                    ></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                            <div class="bb-badge badge-rounded front-badge">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#99ACC2"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-user"
                                >
                                    <path
                                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                    ></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="next-free-time-text-container">
                            <span class="next-free-time-label">{{
                                $t("widgetTab.widget.nextFreeTimeLabel")
                            }}</span>
                            <div class="next-free-time-time-container">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#1A73E8"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-clock"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline
                                        points="12 6 12 12 16 14"
                                    ></polyline>
                                </svg>
                                <span>{{ nextFreeTimeString }}</span>
                            </div>
                        </div>
                    </div>
                    <button
                        class="book-btn"
                        :style="
                            'background:' + form.fields.backgroundColor + ';'
                        "
                    >
                        <span>{{ $t("widgetTab.widget.bookingBtn") }}</span>
                        <i class="la la-angle-right"></i>
                    </button>
                </div>
                <div class="reviews-section" v-show="form.fields.showReviews">
                    <span>{{ $t("widgetTab.widget.reviewsLabel") }} </span>
                    <i class="la la-angle-down"></i>
                </div>
                <div class="footer-section">
                    <span>{{ $t("widgetTab.widget.poweredByLabel") }}</span>
                    <img :src="widgetFooterLogoPath" />
                </div>
            </div>
        </div>
        <div
            class="mobile-submit-btn-footer"
            v-show="!mobileWidgetPreviewVisible"
        >
            <button @click="submit()">{{ $t("widgetTab.saveBtn") }}</button>
        </div>
    </div>
</template>

<script>
import widgetForm from "@/core/services/forms/widgetForm.js";
import formMixin from "@/core/mixins/formMixin.js";
import BBSwitch from "@/view/content/BBForm/BBSwitch.vue";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import moment from "moment";
import i18nService from "@/core/services/i18n.service.js";
import { GET_WIDGET } from "@/core/services/store/widget.module.js";
import { mapGetters } from "vuex";
import widgetFormMixin from "@/core/mixins/widgetFormMixin.js";
import { SET_ALERT_MESSAGES } from "@/core/services/store/alert.module.js";

export default {
    name: "WidgetSettingsTab",
    mixins: [formMixin, widgetFormMixin],
    components: { BBSwitch },
    data() {
        return {
            appearanceOpen: true,
            installationOpen: true,
            mobileWidgetPreviewVisible: false,
            jsInstructionsVisible: false,
            wpInstructionsVisible: false,
            widgetCodeString: "",
            availableColors: [
                "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)",
                "linear-gradient(117.58deg, #00A3AD 0%, #077278 100%)",
                "linear-gradient(117.58deg, #C61575 0%, #980D58 100%)",
                "linear-gradient(116.92deg, #46627E 0.93%, #253342 100%)",
                "linear-gradient(116.92deg, #825BF0 0.93%, #401DBA 100%)",
            ],
        };
    },
    beforeMount() {
        this.form = JSON.parse(JSON.stringify(widgetForm));
        // Dispatch store GET_WIDGET action to get authenticated user company widget from api
        this.$store.dispatch(GET_WIDGET);
    },
    methods: {
        /**
         * Select widget color
         * @param {String} color
         * @return {void}
         */
        selectColor(color) {
            this.form.fields.backgroundColor = color;
        },

        /**
         * Activate logoInput
         * @return {void}
         */
        uploadLogo() {
            this.$refs.logoInput.click();
        },

        /**
         * Handle logo upload
         * @param {Object} event
         * @return {void}
         */
        onFileChange(event) {
            this.form.fields.logo = event.target.files[0];
        },

        /**
         * Show mobile widget preview
         * @return {void}
         */
        showMobileWidgetPreview() {
            this.mobileWidgetPreviewVisible = true;
            let targetElement = document.querySelector(
                ".widget-preview-wrapper"
            );
            disableBodyScroll(targetElement);
        },

        /**
         * Hide mobile widget preview
         * @return {void}
         */
        hideMobileWidgetPreview() {
            this.mobileWidgetPreviewVisible = false;
            let targetElement = document.querySelector(
                ".widget-preview-wrapper"
            );
            enableBodyScroll(targetElement);
        },

        /**
         * Submit the form
         * @return {void}
         */
        submit() {
            this.submitForm()
                .then((response) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: [response.data.message],
                        errorMessages: null,
                    });
                    this.$store.dispatch(GET_WIDGET);
                })
                .catch((error) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: null,
                        errorMessages: [error.response.data.message],
                    });
                });
        },

        /**
         * Copy widget code to clipboard
         * @return {void}
         */
        copyToClipboard() {
            let copyText = document.querySelector("#copy_input");
            copyText.setAttribute("type", "text");
            copyText.select();
            // for mobile devices
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            copyText.setAttribute("type", "hidden");
        },
    },
    computed: {
        ...mapGetters(["myWidget"]),

        /**
         * Return icon arrow class for appearance collapsable element
         * @return {String}
         */
        appearanceArrowClass() {
            if (this.appearanceOpen) {
                return "la la-angle-up";
            }
            return "la la-angle-down";
        },

        /**
         * Return icon arrow class for installation collapsable element
         * @return {String}
         */
        installationArrowClass() {
            if (this.installationOpen) {
                return "la la-angle-up";
            }
            return "la la-angle-down";
        },

        /**
         * Return logo parh for widget
         * @return {String}
         */
        logoPath() {
            if (this.form.fields.logo) {
                return URL.createObjectURL(this.form.fields.logo);
            }
            if (this.form.helpers.logo) {
                return this.form.helpers.logo;
            }
            return process.env.BASE_URL + "media/logos/bb_logo_negative.png";
        },

        /**
         * Return path to widget footer logo
         * @return {String}
         */
        widgetFooterLogoPath() {
            return process.env.BASE_URL + "media/logos/widget-footer-logo.png";
        },

        /**
         * Determine if widget preview is visible
         * @return {Boolean}
         */
        widgetPreviewVisible() {
            if (window.innerWidth < 992) {
                return this.mobileWidgetPreviewVisible;
            }

            return true;
        },

        /**
         * Return string as example for next free time
         * @return {String}
         */
        nextFreeTimeString() {
            return (
                "10:30, " +
                moment()
                    .add(1, "days")
                    .locale(i18nService.getActiveLanguage())
                    .format("dddd D. MMM")
            );
        },
    },
    watch: {
        /**
         * Watch for myWidget property
         */
        myWidget: {
            immediate: true,
            deep: true,
            handler() {
                if (this.myWidget) {
                    this.editWidget(this.myWidget);
                    if (this.myWidget.code) {
                        this.widgetCodeString = this.myWidget.code;
                    } else {
                        this.widgetCodeString =
                            `<iframe src="${process.env.VUE_APP_WIDGET_URL}` +
                            this.myWidget.uuid +
                            `" style="width:100%;height:100%;position:fixed;bottom:0;right:0;" title="Iframe Example"></iframe>`;
                    }
                }
            },
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/components/widget-settings-tab.scss";
</style>
